"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _lightInput = _interopRequireDefault(require("@/components/lightEditor/lightInput.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MsgCheckTextDialog',
  props: {
    catalogContent: {
      type: String,
      default: ''
    }
  },
  components: {
    LightInput: _lightInput.default
  },
  data: function data() {
    return {
      maxLength: 2000,
      content: '',
      dialogVisible: false
    };
  },
  watch: {
    value: function value(newValue) {
      this.content = newValue;
    },
    content: function content(newContent) {
      this.$emit('input', newContent);
    }
  },
  methods: {
    openDialog: function openDialog(value) {
      this.dialogVisible = true;
      this.maxLength = value;
    },
    // 关闭弹窗
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },
    // 确认
    confirm: function confirm() {
      this.content = this.content.toUpperCase().trim().replace(/[ \t]*(\n|\r\n)[ \t]*/g, '$1');
      this.$emit('confirm', this.content);
      this.content = '';
      this.closeDialog();
    },
    // 将父组件的input框里的值拿过来
    getCatalogContent: function getCatalogContent() {
      this.content = this.catalogContent;
    }
  }
};